module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-row', {
    staticClass: "mt-2"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "offset-md": "3"
    }
  }, [_c('v-card', {
    staticClass: "text-center pa-4",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-avatar', {
    staticClass: "ma-1",
    attrs: {
      "size": 240,
      "color": "transparent"
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.logoUrl,
      "lazy-src": ''
    },
    scopedSlots: _vm._u([{
      key: "placeholder",
      fn: function() {
        return [_c('v-row', {
          staticClass: "fill-height ma-0",
          attrs: {
            "align": "center",
            "justify": "center"
          }
        }, [_c('v-progress-circular', {
          attrs: {
            "indeterminate": ""
          }
        })], 1)]
      },
      proxy: true
    }])
  })], 1), _vm._v(" "), _c('h1', {
    staticClass: "ml-4"
  }, [_vm._v("Mailadresse ändern")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n          Lieber Bundesbruder, "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n          deine E-Mailadresse " + _vm._s(_vm.mail) + " ist leider nicht im System vorhanden."), _c('br'), _vm._v("\n          Damit du auf Korpodesk zugreifen kannst musst du entweder beim Schriftführer die E-Mailadresse " + _vm._s(_vm.mail) + " hinterlegen\n          lassen oder du kannst auf dieser Seite eine andere E-Mailadresse verwenden. Du musst immer die Adresse angeben, auf der du\n          auch unsere E-Mails empfängst."), _c('br'), _c('br'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": "Neue E-Mailadresse eintragen",
      "type": "passwemailord"
    },
    model: {
      value: (_vm.neueEmail),
      callback: function($$v) {
        _vm.neueEmail = $$v
      },
      expression: "neueEmail"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    on: {
      "click": function($event) {
        return _vm.updateEmail()
      }
    }
  }, [_vm._v("E-Mailadresse ändern")])], 1), _vm._v("\n        " + _vm._s(_vm.hinweis) + "\n\n      ")], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-088a9384"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/UpdateMail.vue
// module id = 732
// module chunks = 15